var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-popup',{attrs:{"overlay":true},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}},[_c('div',{staticClass:"showLoading"},[_c('van-loading',{attrs:{"type":"spinner","color":"#fff"}}),_c('div',{staticClass:"note"},[_vm._v("数据加载中")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }